import {Component, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { DisplayService } from '../service/display.service';
import { GlobalService } from '../service/global.service';
import { PushService } from '../service/push.service';
import {FactorselectionService} from "../service/factorselection.service";
import {Observable, Subscription} from "rxjs";
import {faMobileAlt, faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import {AuthStateService} from "../service/auth-state.service";

@Component({
  selector: 'app-push',
  templateUrl: './push.component.html',
  styleUrls: ['./push.component.scss']
})
export class PushComponent implements OnInit, OnDestroy {
  pushOptions: string[] = [];
  credId = '';
  errorDiv: boolean = false;
  errorMsg: String;
  selectPush: boolean = false;
  counter: number;
  factorSelection: boolean = false;
  value: string = '';
  selectedCredValue: string;
  multifactor: boolean = false;
  ready: boolean;
  pageSubs: Subscription[] = new Array<Subscription>();
  pushStatusMsg: any;
  phoneIcon = faMobileAlt;
  statusHandler$: Observable<Object>;
  resendIcon = faSyncAlt;
  timeoutErr: boolean;
  isRegisterFlow: boolean = false;

  constructor(private router: Router,
              private displayService: DisplayService,
              public pushService: PushService,
              public globalService: GlobalService,
              private authStateService: AuthStateService,
              private factorselectionService: FactorselectionService) {
    this.displayService.disableBrowserBackButton();
  }

  ngOnInit() {
    if (this.displayService.userName == null) {
      this.router.navigate(["../"]);
    }

    this.isRegisterFlow = location.href.endsWith("register/totp_push");

    if (this.isRegisterFlow) {
      this.registerFlow();
    } else {
      this.factorFlow();
    }

    this.displayService.focusNthField();
  }


  private registerFlow() {
    this.multifactor = false;
    this.factorSelection = true;
    let data = this.router.lastSuccessfulNavigation?.extras?.state?.data;
    this.selectedCredValue = data?.credValue;
    this.credId = data?.credId;
    this.ready = true;
    this.verifyPush();
  }

  private factorFlow() {
    this.factorSelection = this.displayService.factorSelection;
    if (this.displayService.action === "PUSH_SELECTION") {
      this.selectPush = this.displayService.selectPush;
    }
    this.pushOptions = this.displayService.pushOptions;
    this.pushOptions.forEach(function (value) {
      if (value["default"] === true) {
        this.credId = value["credId"];
        this.selectedCredValue = value["credValue"];
      }
    }.bind(this));
    if (this.pushOptions.length === 1) {
      this.credId = (<any>this.pushOptions[0]).credId;
      this.selectedCredValue = (<any>this.pushOptions[0]).credValue;
      this.onGenerate();
    }
    else {
      this.multifactor = true;
    }
  }

  selectedCredential(event: any) {
    this.multifactor = false;

    if (event) {
      this.credId = event.credId;
      this.selectedCredValue = event.credValue;
    }
    this.selectPush = false;
    this.onGenerate();
  }

  onGenerate() {
    this.pushStatusMsg = "Sending push notification . . .";
    this.ready = false;
    this.timeoutErr = false;
    this.errorDiv = false;
    this.counter = 0;
    this.pushService.onGenerate(this.credId)
      .subscribe({
        next: (data) => {
          this.displayService.updateCurrentFactorLevel(data);
          if (data["nextaction"] === "PUSH_AUTH") {
            this.errorMsg = "";
            this.errorDiv = false
            this.selectPush = false;
            this.ready = true;
            this.pushStatusMsg = "";
            this.displayService.flowState = data["flowState"];
            this.verifyPush();
          }
        },
        error: (err) => {
          this.errorDiv = this.displayService.errorDiv;
          this.setError(this.displayService.errorMsg);
        }
      });
  }

  verifyPush() {
    this.errorDiv = false;
    this.statusHandler$ = this.pushService.getVerifyObservable(this.credId);

    this.pageSubs.push(
      this.statusHandler$
        .subscribe({
          next: (data) => {
            // Determine state of response, and continue or throw error
            if (this.isRegisterFlow) {
              this.processRegisterStatusData(data);
            } else {
              this.processFactorStatusData(data);
            }
          },
          error: (err) => this.setError("Transaction failed unexpectedly")
        })
    );
  }

  private processFactorStatusData(data) {
    if (data?.['data']?.["status"] === "AUTHENTICATED") {
      this.ready = false;
      this.displayService.routeActions(data);
    } else if (data?.['data']?.["status"] === "REJECTED") {
      this.setError("Transaction denied");
    } else if (data?.["errorCode"]) {
      this.setError("Transaction failed");
    } else if (data?.["data"]?.["status"] == "TIMED_OUT") {
      this.errorDiv = true;
      this.errorMsg = "Transaction timed out";
      this.timeoutErr = true;
      this.ready = true;
    }
  }

  private processRegisterStatusData(data) {
    if (data?.["status"] === "AUTHENTICATED") {
      this.ready = false;
      this.router.navigateByUrl("self-service", {state: {newCredAdded: true}});
    } else if (data?.["status"] === "REJECTED") {
      this.setError("Transaction denied");
    } else if (data?.["errorCode"]) {
      this.setError("Transaction failed");
    } else if (data?.["status"] == "TIMED_OUT") {
      this.errorDiv = true;
      this.errorMsg = "Transaction timed out";
      this.timeoutErr = true;
      this.ready = true;
    }
  }

  /**
    Only timeout error is recoverable. If any other error occurs, then the x-flow-state will be
    invalidated. Hence, any other type of error is unrecoverable.
  **/
  setError(errMsg) {
    this.errorDiv = true;
    this.displayService.errorMsg = errMsg;
    this.ready = true;

    if (this.isRegisterFlow) {
      // One failure during registration is unrecoverable failure
      this.errorMsg = "Unable to complete registration at this time. "
    } else {
      // If not registration, then restart is needed
      this.authStateService.setAuthStatusRestartNeeded();
    }
  }

  chooseAnother() {
    this.pushStatusMsg = "";
    this.errorDiv = false;
    this.ready = false;
    this.pageSubs.push(
      this.factorselectionService.chooseAnother()
    );
  }

  ngOnDestroy() {
    this.pageSubs.forEach((sub) => {
      sub?.unsubscribe();
    });
  }
}
